export enum SexEnum {
  //never change order
  FEMALE = 0,
  MALE = 1,
  ALL = 2,
}

export enum SexStringEnum {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
  OTHER = 'OTHER',
}

export enum ApiSexEnum {
  FEMALE = 'FEMALE',
  MALE = 'MALE',
}
